import React, { ComponentProps } from "react";
import { Flex, getTextColor, Icon, PopupMenu, Text, utils } from "@thenounproject/lingo-core";
import styled from "styled-components";

type ColorPickerButtonProps = {
  popupSource: string;
  displayColor: string | null;
  displayLabel: string;
  iconId: string;
  menuVisible: boolean;
  onShowMenu: () => void;
  onHideMenu: () => void;
  children: React.ReactNode;
  menuHPos?: ComponentProps<typeof PopupMenu>["hPos"];
  swatchStyle?: React.CSSProperties;
  label?: string;
};

const Container = styled(Flex).attrs(props => {
  return {
    border: "default",
    borderRadius: utils.getBorderRadius("defaultOuter", null, props),
    width: "100%",
    p: "1px",
    alignItems: "center",
    overflow: "hidden",
    background: "white",
    style: { cursor: "pointer" },
  };
})``;

const ColorPreview = styled(Flex).attrs(props => {
  return {
    width: "28px",
    height: "28px",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: utils.getBorderRadius("default", null, props),
  };
})``;

const ColorPickerButton: React.FC<ColorPickerButtonProps> = ({
  popupSource,
  displayColor,
  displayLabel,
  iconId,
  menuVisible,
  onShowMenu,
  onHideMenu,
  children,
  menuHPos = "alignRight",
  swatchStyle = {},
  label,
}) => {
  const noDisplayColor =
    !displayColor || displayColor === "rgba(255, 255, 255, 0)" || displayColor === "transparent";

  const pickerButton = (
    <>
      <Container data-popup-source={popupSource} onClick={onShowMenu}>
        <ColorPreview
          background={displayColor || "transparent"}
          style={{
            ...swatchStyle,
            border: noDisplayColor ? "1px solid #E1E2E4" : "none",
          }}>
          <Icon iconId={iconId} size="16px" fill={getTextColor(displayColor || "#fafafa")} />
        </ColorPreview>
        <Text pl="s" font="ui.tiny">
          {displayLabel}
        </Text>
      </Container>
      <PopupMenu
        open={menuVisible}
        close={onHideMenu}
        source={popupSource}
        vPos="floatBelow"
        hPos={menuHPos}
        maxHeight={550}>
        {children}
      </PopupMenu>
    </>
  );

  if (label) {
    return (
      <Flex flexDirection="column" alignItems="center" gap="4px" flex="1">
        {pickerButton}
        <Text font="ui.xsmall" color="grayDarker">
          {label}
        </Text>
      </Flex>
    );
  }

  return pickerButton;
};

export default ColorPickerButton;
